import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { TagCompraService } from '../../../../shared/services/apis/compras/tag-compra.service';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { TagComprasRequest } from '../../../../shared/services/requests/compras/tag-compra.request';
import { UiTagComponent } from '../../../../shared/components/ui-tag/ui-tag.component';

@Component({
  selector: 'app-tag-compra-cadastro',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    LoadingBoxComponent,
    FooterActionComponent,
    HeaderComponent,
    UiTagComponent,
  ],
  templateUrl: './tag-compra-cadastro.component.html',
  styleUrl: './tag-compra-cadastro.component.css',
})
export class TagCompraCadastroComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Suprimentos;
  public form: FormGroup;
  public isLoading: boolean = false;
  public isSaving: boolean = false;
  public isEdicao: boolean = false;
  public idTag: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private tagService: TagCompraService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.route.params.subscribe(params => {
      if (params['idTagCompra']) {
        this.idTag = +params['idTagCompra'];
        this.isEdicao = true;
        this.carregarTag();
      }
    });
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      descricao: ['', Validators.required],
      cor: ['#C0C0C0', Validators.required],
    });
  }

  public onColorChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const color = input.value;
    if (color && color.startsWith('#') && (color.length === 4 || color.length === 7)) {
      this.form.get('cor')?.setValue(color, { emitEvent: false });
    }
  }

  private carregarTag(): void {
    this.isLoading = true;
    this.tagService.getById(this.idTag).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription || 'Erro ao carregar tag.', AlertType.error);
          this.voltar();
          return;
        }
        if (res.tag) {
          this.form.patchValue({ descricao: res.tag.descricao, cor: res.tag.cor });
        }
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao carregar a tag.', AlertType.error);
        this.voltar();
      },
    });
  }

  public salvar(): void {
    if (this.form.invalid) {
      this.alertService.show('Atenção', 'Preencha todos os campos obrigatórios.', AlertType.warning);
      return;
    }

    this.isSaving = true;
    const request: TagComprasRequest = this.form.value;
    if (this.isEdicao) {
      this.tagService
        .update(this.idTag, request)
        .subscribe({ next: res => this.tratarRetorno(res), error: err => this.tratarErro(err) });
    } else {
      this.tagService
        .create(request)
        .subscribe({ next: res => this.tratarRetorno(res), error: err => this.tratarErro(err) });
    }
  }

  private tratarRetorno(res: any): void {
    this.isSaving = false;
    if (res.isError) {
      this.alertService.show('Atenção', res.errorDescription || 'Erro ao salvar tag.', AlertType.warning);
    } else {
      this.alertService.show('Sucesso', 'Tag salva com sucesso.', AlertType.success);
      this.voltar();
    }
  }

  private tratarErro(_: any): void {
    this.isSaving = false;
    this.alertService.show('Erro', 'Ocorreu um erro ao salvar.', AlertType.error);
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/suprimentos/tags-compra']);
  }
}
